export const hero = {
  "title": "Scambia tra host,",
  "titleHighlight": "ovunque in Europa",
  "subtitle": "Club di scambio europeo riservato agli host Airbnb valutati 4.5+ con abbonamento unico Europa.",
  "cta": "Inizia lo scambio",
  "learnMore": "Saperne di più",
  "stats": {
    "owners": "Proprietari attivi",
    "countries": "Paesi disponibili",
    "exchanges": "Scambi realizzati"
  },
  "slogans": {
    "slogan1": {
      "title": "Club privato",
      "highlight": "host Airbnb 4.5+",
      "subtitle": "Un accesso riservato agli host ben valutati per scambiare in un ambiente di fiducia."
    },
    "slogan2": {
      "title": "Offerta lancio 2026",
      "highlight": "-50% per i primi 1000",
      "subtitle": "25EUR/anno invece di 50EUR/anno, con prezzo bloccato a vita."
    },
    "slogan3": {
      "title": "Prezzo garantito a vita",
      "highlight": "Primi 1000 membri",
      "subtitle": "I primi 1000 iscritti mantengono la loro tariffa a vita."
    },
    "slogan4": {
      "title": "Nessun intermediario,",
      "highlight": "solo relazioni",
      "subtitle": "Una comunità di fiducia dove si scambiano soggiorni, non si vendono notti."
    },
    "slogan5": {
      "title": "Unisciti al club",
      "highlight": "DONKEY TRAVEL",
      "subtitle": "Il club di scambio pensato per gli host Airbnb attivi in Europa."
    },
    "slogan6": {
      "title": "Bassa stagione",
      "highlight": "ottimizzata",
      "subtitle": "Trasforma i tuoi periodi morti in opportunitá di viaggio."
    },
    "slogan7": {
      "title": "Fai una pausa,",
      "highlight": "evita il burnout",
      "subtitle": "Respira tra due periodi di accoglienza scambiando la tua casa."
    },
    "slogan8": {
      "title": "Lo spirito del viaggio,",
      "highlight": "quello vero",
      "subtitle": "Incontra altri host e scopri nuovi luoghi a costi ridotti."
    },
    "slogan9": {
      "title": "100% Fatto in Francia",
      "highlight": "(Piccardia)",
      "subtitle": "Non la Silicon Valley, ma la Valle dell'Alta Somme. Una piattaforma artigianale, umana e fiera delle sue radici."
    }
  }
};
